import '@f-fertighaus/components/YoutubeVideo/YoutubeVideoHTML'

void (async function () {
  const carousels = document.querySelectorAll('.js-carousel')

  if (carousels.length > 0) {
    const { default: Glide } = await import(
      /*
        webpackChunkName: "Glide",
        webpackMode: "lazy"
      */
      '@glidejs/glide'
    )

    const initCarousel = carousel => {
      const glideElement = new Glide(carousel, {
        type: 'slider',
        classes: {
          activeNav: 'is-active'
        },
        rewind: true,
        keyboard: false,
        startAt: 0,
        bound: 1,
        perView: 1,
        gap: 0
      })

      glideElement.mount()
    }

    for (const carousel of carousels) {
      initCarousel(carousel)
    }
  }
})()
